<template>
	<ion-button
		id="forgot-password"
		type="button"
		color="medium"
		fill="clear"
		:disabled="props.disabled"
		@click="showEmailAlert()"
	>
		{{ $t("login.forgot-password") }}
	</ion-button>
</template>

<script setup lang="ts">
	import { useSendPasswordReset } from "@/composables/useSendPasswordReset";
	import { alertController, IonButton } from "@ionic/vue";
	import posthog from "posthog-js";
	import { useI18n } from "vue-i18n";

	const props = defineProps<{
		disabled: boolean;
		email: string;
	}>();

	const { t } = useI18n();

	const sendPasswordReset = useSendPasswordReset();
	function showEmailAlert() {
		posthog.capture("login:forgot_password_click");

		alertController
			.create({
				header: t("login.reset-password"),
				message: t("login.reset-password-message"),
				inputs: [
					{
						placeholder: t("login.email-address"),
						name: "email",
						type: "email",
						value: props.email,
					},
				],
				buttons: [
					{
						text: t("common.cancel"),
						role: "cancel",
					},
					{
						text: t("common.submit"),
						handler: async ({ email }) => {
							await handleSubmit(email);
						},
					},
				],
			})
			.then((alert) => alert.present());
	}

	async function handleSubmit(email: string) {
		if (!email) return;

		const success = await sendPasswordReset(email);

		if (success) {
			alertController
				.create({
					header: t("login.request-successful"),
					message: t("login.request-message"),
					buttons: [{ text: t("common.ok"), role: "cancel" }],
				})
				.then((alert) => alert.present());
		}

		posthog.capture("login:forgot_password_send", {
			email: email,
		});
	}
</script>
